import React, { SyntheticEvent } from "react";
import { Box, Grid, Typography } from "@mui/material";
import "../dossier-styles.scss";
import CustomToggleButtonGroup from "../../../UIElements/CustomToggleButtonGroup";
import DownloadBtn from "../../../UIElements/DownloadBtn";
import { DossierHeaderProps } from "./DossierHeader";

export default function InstructorDossierHeaderContent({
    setActiveTab,
    activeTab,
    tabsMenu,
    headerInfo,
    downloadAllDoc,
}: DossierHeaderProps) {
    const {
        establishmentName,
        instructorReview,
        instructionInfos,
        processingStepThreshold,
    } = headerInfo;

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                flexWrap: "wrap",
                gap: "1.5rem",
            }}
        >
            <Grid container spacing={1.5}>
                <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "1.5rem",
                        alignSelf: "stretch",
                        width: "100%",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "0.5rem",
                            alignSelf: "stretch",
                        }}
                    >
                        <Typography
                            sx={{
                                color: "#023",
                                textAlign: "left",
                                textEdge: "cap",
                                fontFamily: "Roboto",
                                fontSize: "0.875rem",
                                fontStyle: "normal",
                                fontWeight: "500",
                                lineHeight: "normal",
                                width: "100%",
                            }}
                        >
                            #{headerInfo.dossierId}
                        </Typography>
                        <Typography
                            sx={{
                                color: "#005499",
                                fontFamily: "Roboto",
                                fontSize: "1.75rem",
                                fontStyle: "normal",
                                fontWeight: "500",
                                lineHeight: "normal",
                            }}
                        >
                            Dossier de qualification pour l'
                            {headerInfo.referencielName}
                        </Typography>{" "}
                        {/* </Box> */}
                        {establishmentName ? (
                            <Typography
                                sx={{
                                    color: "#023",
                                    fontFamily: "Roboto",
                                    fontSize: "1.25rem",
                                    fontStyle: "normal",
                                    fontWeight: "400",
                                    lineHeight: "normal",
                                }}
                            >
                                {establishmentName}
                            </Typography>
                        ) : null}
                    </Box>

                    {instructionInfos ? (
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "flex-start",
                                alignSelf: "stretch",
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    gap: "0.5rem",
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: "#555A5D",

                                        fontFamily: "Roboto",
                                        fontSize: "0.875rem",
                                        fontStyle: "normal",
                                        fontWeight: 400,
                                        lineHeight: "normal",
                                        alignSelf: "stretch",
                                    }}
                                >
                                    Affecté le
                                </Typography>
                                <Typography
                                    variant="h1"
                                    sx={{
                                        color: "#555A5D",

                                        fontFamily: "Roboto",
                                        fontSize: "1rem",
                                        fontStyle: "normal",
                                        fontWeight: 500,
                                        lineHeight: "normal",
                                        alignSelf: "stretch",
                                    }}
                                >
                                    <b>{instructionInfos.assignedDate}</b>
                                </Typography>
                            </Box>
                            {!instructorReview ? (
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                        gap: "0.5rem",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: "#555A5D",

                                            fontFamily: "Roboto",
                                            fontSize: "0.875rem",
                                            fontStyle: "normal",
                                            fontWeight: 400,
                                            lineHeight: "normal",
                                            alignSelf: "stretch",
                                        }}
                                    >
                                        Instruction à fournir avant le
                                    </Typography>
                                    <Typography
                                        variant="h1"
                                        sx={{
                                            color: "#555A5D",

                                            fontFamily: "Roboto",
                                            fontSize: "1rem",
                                            fontStyle: "normal",
                                            fontWeight: 500,
                                            lineHeight: "normal",
                                            alignSelf: "stretch",
                                        }}
                                    >
                                        <b>
                                            {
                                                instructionInfos.instructionDeadline
                                            }
                                        </b>
                                    </Typography>
                                </Box>
                            ) : null}
                            {/* Aller/retour */}

                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    gap: "0.5rem",
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: "#555A5D",

                                        fontFamily: "Roboto",
                                        fontSize: "0.875rem",
                                        fontStyle: "normal",
                                        fontWeight: 400,
                                        lineHeight: "normal",
                                        alignSelf: "stretch",
                                    }}
                                >
                                    Aller/retour
                                </Typography>
                                <Typography
                                    variant="h1"
                                    sx={{
                                        color: "#555A5D",

                                        fontFamily: "Roboto",
                                        fontSize: "1rem",
                                        fontStyle: "normal",
                                        fontWeight: 500,
                                        lineHeight: "normal",
                                        alignSelf: "stretch",
                                    }}
                                >
                                    <b>{`${instructionInfos.processStep}/${processingStepThreshold}`}</b>
                                </Typography>
                            </Box>

                            {instructorReview ? (
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                        gap: "0.5rem",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: "#555A5D",

                                            fontFamily: "Roboto",
                                            fontSize: "0.875rem",
                                            fontStyle: "normal",
                                            fontWeight: 400,
                                            lineHeight: "normal",
                                            alignSelf: "stretch",
                                        }}
                                    >
                                        Avis instructeur
                                    </Typography>
                                    <Typography
                                        variant="h1"
                                        sx={{
                                            color: "#555A5D",

                                            fontFamily: "Roboto",
                                            fontSize: "1rem",
                                            fontStyle: "normal",
                                            fontWeight: 500,
                                            lineHeight: "normal",
                                            alignSelf: "stretch",
                                        }}
                                    >
                                        <b>{instructorReview}</b>
                                    </Typography>
                                </Box>
                            ) : null}
                        </Box>
                    ) : null}
                </Grid>
                <Grid
                    xs={12}
                    item
                    sm={6}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        gap: "1.5rem",
                    }}
                >
                    <Box
                        sx={{
                            display: "inline-flex",
                            justifyContent: "flex-end",
                            alignItems: "end",
                            float: "right",
                            minHeight: "unset",
                            gap: "0.5rem",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "flex-end",
                                alignItems: "end",
                                justifyContent: "space-between",
                                marginTop: "1.5rem",
                                "@media (max-width:1024px)": {
                                    width: "100%",
                                },
                            }}
                        >
                            <DownloadBtn
                                label={"documents"}
                                title={"Télécharger tous les documents"}
                                customsx={{
                                    margin: 0,
                                    float: "right",
                                    height: "1.87rem",
                                    padding: "0.5rem 1rem",
                                    marginLeft: "auto",
                                    "@media (max-width:1024px)": {
                                        width: "100%",
                                        marginTop: 0,
                                    },
                                }}
                                onClick={async () => {
                                    await downloadAllDoc();
                                }}
                            />
                        </Box>
                    </Box>

                    <Box
                        sx={{
                            alignSelf: "flex-end",
                            marginTop: "auto",
                            "@media (max-width:1024px)": {
                                flexDirection: "column",
                                width: "100%",
                            },
                        }}
                    >
                        <CustomToggleButtonGroup
                            tabsMenu={tabsMenu}
                            active={activeTab}
                            handleChange={(e: SyntheticEvent, value: string) =>
                                setActiveTab(value)
                            }
                        />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}
